import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const AlipayIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_149023)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="#00A1E9"
        />
        <path
          d="M11.1068 8.80078C9.83169 8.80078 8.80005 9.8333 8.80005 11.1081V20.8939C8.80005 22.1677 9.83169 23.2008 11.1068 23.2008H20.8937C22.1678 23.2008 23.1999 22.1677 23.1999 20.8939V20.7938C23.157 20.7759 19.4575 19.2328 17.5772 18.3287C16.3086 19.8898 14.6723 20.8369 12.9734 20.8369C10.1006 20.8369 9.12509 18.3227 10.4853 16.6676C10.7819 16.3068 11.2865 15.9621 12.0695 15.7691C13.2945 15.4682 15.244 15.9571 17.0712 16.5601C17.3999 15.9546 17.6764 15.2878 17.8823 14.5778H12.2515V14.0075H15.155V12.9849H11.6384V12.4142H15.155V10.9555C15.155 10.9555 15.155 10.7097 15.404 10.7097H16.8234V12.4142H20.2998V12.9849H16.8234V14.0075H19.6611C19.3895 15.1199 18.9772 16.1439 18.4597 17.0429C19.3209 17.3544 20.094 17.6499 20.6702 17.8428C22.5919 18.4859 23.1305 18.5645 23.2 18.5727V11.1081C23.2 9.83338 22.168 8.80082 20.8939 8.80082H11.1069L11.1068 8.80078ZM12.6859 16.6028C12.5626 16.6042 12.4387 16.6109 12.3139 16.6232C11.9542 16.6594 11.2788 16.8181 10.9095 17.1447C9.80273 18.11 10.4652 19.8746 12.7052 19.8746C14.0074 19.8746 15.3084 19.0421 16.3305 17.709C15.0128 17.0661 13.8779 16.5889 12.6858 16.6028H12.6859Z"
          fill="white"
        />
      </g>

      <defs>
        <clipPath id="clip0_2177_149023">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
